module.exports = __webpack_public_path__ + "media/parks.93330709.png";